import styled from 'styled-components';

export const PreloaderPosition = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 30px;
`;

export const ImgSize = styled.img`
  height: 100px;
`;
